import styled from 'styled-components';

export const Tr = styled.tr`
  &:nth-child(n) {
    text-align: center;
    letter-spacing: 0px;
    white-space: initial;
    padding: 0;
  }
`;

export const P = styled.p`
  line-height: 0;
  font-size: 0.85rem;
  padding: 0;
  margin: 0;
  font-weight: 500;
`;

export const Td = styled.td`
  padding: 0px;
  display: 'flex';
  white-space: initial;
  justify-content: 'center';
  align-items: 'center';
  align-content: 'center';
`;
